<uikit-layout class="overflow-hidden">
	@if (!$clientDroitsLoading() && $showLayout()) {
		<ng-template #layoutTopbar>
			<cba-top-bar
				[fullClient]="$fullClient()"
				[loading]="$loadingFullClient()"
				[droits]="$clientDroits()"
			/>
		</ng-template>
	}

	@if (!$clientDroitsLoading() && $showLayout()) {
		<ng-template
			#layoutDesktopMenuContent
			*hasFullAccess="$clientDroits()"
		>
			<cba-side-nav
				[fullClient]="$fullClient()"
				[loading]="$loadingFullClient()"
				[droits]="$clientDroits()"
			/>
		</ng-template>
	}

	<ng-template #layoutAppContent>
		<!-- APP CONTENT -->
		<div
			id="appScrollContainer"
			class="scrollbar mx-auto h-full w-full justify-center overflow-auto"
		>
			<div
				app-struts
				class="relative z-[1] hidden overflow-auto"
			></div>
			<router-outlet />
		</div>
	</ng-template>
</uikit-layout>
